export function comasToDots(value: string): string {
  return value.replace(/,/g, '.');
}
